import React from 'react';
import { Typography } from '@mui/material';
import { Room as RoomIcon } from '@mui/icons-material';
import { StyledListItem, StyledListItemIcon, StyledListItemText } from '../styles';
var CustomerListItemAddress = function (_a) {
    var _b = _a.address, line1 = _b.line1, line2 = _b.line2, city = _b.city, county = _b.county, state = _b.state, zipcode = _b.zipcode;
    return (React.createElement(StyledListItem, null,
        React.createElement(StyledListItemIcon, null,
            React.createElement(RoomIcon, null)),
        React.createElement(StyledListItemText, { primary: React.createElement(Typography, { color: line1 || line2 ? 'text.primary' : 'text.secondary', variant: "body2" }, line1 || line2 ? "".concat("".concat(line1, " ")).concat(line2) : 'Missing'), secondary: React.createElement(Typography, { color: city || state || county || zipcode
                    ? 'text.primary'
                    : 'text.secondary', variant: "body2" }, city || state || county || zipcode
                ? "".concat("".concat(city, ", ")).concat("".concat(state, " ")).concat("".concat(county, " ")).concat(zipcode)
                : 'Missing') })));
};
export default CustomerListItemAddress;
//# sourceMappingURL=CustomerListItemAddress.js.map